import React from 'react';
import { SortBy, } from '../types/ContactsFilterState.js';
const DEFAULT_STATE = {
    sorting: SortBy.NameAscending,
    nameFilter: '',
    factionFilter: '',
};
export function useContactsFilter() {
    const [state, setState] = React.useState(DEFAULT_STATE);
    const updateSorting = React.useCallback((newValue) => {
        setState((prev) => ({ ...prev, sorting: newValue }));
    }, []);
    const updateNameFilter = React.useCallback((newValue) => {
        setState((prev) => ({ ...prev, nameFilter: newValue }));
    }, []);
    const updateFactionFilter = React.useCallback((newValue) => {
        setState((prev) => ({ ...prev, factionFilter: newValue }));
    }, []);
    const clearAllFilters = React.useCallback(() => {
        setState(DEFAULT_STATE);
    }, []);
    const actions = {
        updateSorting,
        updateNameFilter,
        updateFactionFilter,
        clearAllFilters,
    };
    const applyFiltersAndSort = React.useCallback((characters) => {
        let result = [...characters];
        if (state.nameFilter) {
            const lowerFilter = state.nameFilter.toLowerCase();
            result = result.filter((c) => c.name.toLowerCase().includes(lowerFilter));
        }
        if (state.factionFilter) {
            result = result.filter((c) => c.affiliations.includes(state.factionFilter));
        }
        result.sort((a, b) => {
            const comparison = a.name.localeCompare(b.name);
            return state.sorting === SortBy.NameAscending ? comparison : -comparison;
        });
        return result;
    }, [state.nameFilter, state.factionFilter, state.sorting]);
    const getUniqueFactions = React.useCallback((characters) => {
        const factionSet = new Set();
        for (const character of characters) {
            for (const affiliation of character.affiliations) {
                factionSet.add(affiliation);
            }
        }
        return [...factionSet].sort();
    }, []);
    return {
        state,
        actions,
        applyFiltersAndSort,
        getUniqueFactions,
    };
}
//# sourceMappingURL=useContactsFilter.js.map